import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export function Loader() {
  return (
    <div data-testid="auth-loader" className="flex min-h-screen items-center justify-center bg-navy">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-gold/30 border-t-gold" />
    </div>
  );
}

export default function ProtectedRoute({ children, admin = false }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to={admin ? "/admin/login" : "/login"} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/admin/login" replace />;
  return children;
}
